import { render, staticRenderFns } from "./IntroCardView.vue?vue&type=template&id=60d5c465&scoped=true"
import script from "./IntroCardView.vue?vue&type=script&lang=ts"
export * from "./IntroCardView.vue?vue&type=script&lang=ts"
import style0 from "./IntroCardView.vue?vue&type=style&index=0&id=60d5c465&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d5c465",
  null
  
)

export default component.exports